import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import { withPrefix } from 'gatsby'

const QAPage = () => (
  <Layout>
    <SEO
      title="Q&A | 日本商工会議所「日商簿記-1グランプリ2024」公式サイト"
      description="「日商簿記-1グランプリ2024」Q&Aページです。"
    />
    <div className="title"><h1><img src={withPrefix('/images/icon_under_0003.png')} alt="Q&A｜日本商工会議所「日商簿記-1グランプリ2024」公式サイト" /></h1></div>
    <div className="description" id="js-height">
    <div className="qabox">
      <div className="qaindex">
        <span>Q1.</span>
        <p>簿記－１グランプリに参加できる条件を教えて下さい。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>
          特定の条件を満たす方を除き、すべての方がご参加いただけます。<br />
          （ご参加いただけない方：公認会計士、税理士などの会計専門職資格所有者および、簿記の指導に従事する教員）<br />
          ※ 公認会計士試験（短答式）合格者、税理士試験科目合格者は参加可能
        </p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q2.</span>
        <p>過去に日商簿記１級を取得していますが、参加は可能ですか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>過去に日商簿記１級を取得されている方でもご参加いただけます。</p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q3.</span>
        <p>チームのメンバー構成に制限はありますか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>メンバーは3人以上5人以下となります。また、一人が複数のチームに重複して登録することはできません。</p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q4.</span>
        <p>学校、企業、組織等同一の団体に所属している人以外ではチームを組めないのでしょうか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>
          チーム構成に制限はありませんが、事務局より代表者へ連絡を入れることがありますので、チーム内で連絡が取れる体制を整えてください。<br />
          また、今回の簿記－１グランプリは、同一団体からの参加チーム数の制限はありません。
        </p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q5.</span>
        <p>メンバー登録の際に注意はありますか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>
          登録の際にメンバー登録の他に、代表者の連絡先、チーム名、所属等をご記入いただきます。チーム名が重複した場合など、変更をお願いすることがあります。<br />
          表彰等の資料となりますので、所属先（高校名）等は正式名をご記入ください。
        </p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q6.</span>
        <p>簿記－１グランプリでの点数は、通常の簿記１級試験の点数としてカウントされますか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>通常受験と同様に、正式な１級試験の結果となりますので、合格基準を満たせば日商簿記１級合格となります。</p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q7.</span>
        <p>試験当日にメンバーが欠席した場合はどうなりますか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>欠席されたメンバーは0点扱いとなり、受験したメンバーが2人以下となった場合グランプリの対象外となります。</p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q8.</span>
        <p>グランプリの結果の確認方法を教えてください。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>
          簿記－１グランプリ特設サイト上でご確認いただけます。<br />
          上位チームにつきましては、サイト上で合計点、チーム名を公開いたします。<br />
          上位チーム以外は点数分布での発表を予定しています。<br />
          参加者個人の点数が公表されることはありません。
        </p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q9.</span>
        <p>表彰チーム数を教えてください。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>最優秀チームが表彰対象となりますが、参加チーム数の状況に応じて上位入賞チームについても表彰いたします。また、部門賞（高校生の部）も同様です。</p>
      </div>
    </div>
    <div className="qabox">
      <div className="qaindex">
        <span>Q10.</span>
        <p>どのように表彰が行われますか。</p>
      </div>
      <div className="qaindex">
        <span>A.</span>
        <p>表彰対象チームの代表者に、事務局から詳細を連絡いたします。</p>
      </div>
    </div>
    </div>
  </Layout>
)

export default QAPage
